import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Button} from 'shells/button/button';
import {SlideshowControls} from 'shells/carousel/slideshow-controls';
import {Link} from 'shells/link/link';
import {RightFrame, ModalMain, FooterWithControls} from 'shells/modal/step-modal/layout';
import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {Body} from 'shells/typography/body';
import {ModalHeader} from 'shells/typography/modal-header';
import {ModalSubheader} from 'shells/typography/modal-subheader';
import {ModalTitle} from 'shells/typography/modal-title';

type Props = {
    goBack: () => void;
    nextPage: string;
};

export function InitialSync(props: Props) {
    const [shouldSyncPastCalls, setShouldSyncPastCalls] = React.useState<'0' | '1'>('1');

    return (
        <RightFrame>
            <ModalMain>
                <SpacerGroup mb={32}>
                    <ModalHeader>How about we give you a head start?</ModalHeader>
                    <ModalSubheader>
                        Nutshell only pulls in new phone calls moving forward but we can add some
                        older calls to get you started.
                    </ModalSubheader>
                </SpacerGroup>
                <SpacerGroup mb={32}>
                    <ModalTitle>Should we import some of your recent calls?</ModalTitle>
                    <RadioGroup
                        name='sync-old'
                        selectedValue={shouldSyncPastCalls}
                        // @ts-expect-error
                        onChange={setShouldSyncPastCalls}
                    >
                        <Radio value='1'>
                            <Body>Yes, add phone calls from the last 30 days</Body>
                        </Radio>
                        <Radio value='0'>
                            <Body>No, do not sync any previous calls</Body>
                        </Radio>
                    </RadioGroup>
                </SpacerGroup>
            </ModalMain>
            <FooterWithControls
                controls={<SlideshowControls selectedSlide={1} slideCount={3} />}
                buttons={
                    <React.Fragment>
                        <Button variant='text' onClick={props.goBack}>
                            Back
                        </Button>
                        <Link
                            variant='button-primary'
                            size='big'
                            // @ts-expect-error
                            as={RoutedLink}
                            to={`${props.nextPage}&shouldSyncPastCalls=${shouldSyncPastCalls}`}
                        >
                            Next
                        </Link>
                    </React.Fragment>
                }
            />
        </RightFrame>
    );
}
